export default Object.freeze({
  // Global messages and UI elements
  common: {
    // User roles
    student: "Student",
    admin: "Admin",
    teacher: "Teacher",
    staff: "Staff",
    school: "School",
    system: "System",

    // Actions
    log_out: "Log Out",
    edit: "Edit",
    submit: "Submit",
    go_back: "Go back",
    select_one: "Select one",
    this_option_is_required: "This option is required",
    this_field_is_required: "This field is required",
    /** Visible suffix for required fields — WCAG 1.4.1 vs red-dot-only cues */
    required_indicator: "(required)",
    reason_for_pass_is_required: "Reason for pass is required",
    start_point_and_destination_point_should_not_be_the_same:
      "Start point and destination point should not be the same",
    the_pin_may_not_be_greater_than_6_characters:
      "The pin may not be greater than 6 characters",
    the_pin_should_be_at_least_4_characters:
      "The pin should be at least 4 characters",
    cancel_request: "Cancel Request",
    cancel_pass: "Cancel Pass",
    close: "Close",
    view: "View",
    do_you_really_want_to_cancel_the_pass:
      "Do you really want to cancel the pass?",
    cancel: "Cancel",
    staff_use_only: "Staff use only",
    enter_your_pin: "Enter your PIN",
    approve: "Approve",
    arrived: "Arrived",
    in_out: "In/Out",
    returning: "Returning",
    end_keep: "End/Keep",
    end: "End",
    enter_room_pin: "Enter room PIN",
    check_in: "Check-in",
    the_time_must_be_30_minutes_from_now_and_not_more_than_a_month:
      "The time must be 30 minutes from now and not more than a month!",
    you_must_pick_a_time_between_6am_and_5pm:
      "You must pick a time between 6AM and 5PM.",
    select_teacher_or_rooms: "Select Teacher or Rooms",

    // Navigation and UI
    favorites: "Favorites",
    add_favorite_teacher_room: "Add favorite Teacher / Room",
    add_remove_favorites: "Add/Remove Favorites",
    manage_order: "Manage Order",
    reset_date: "Reset date",
    infraction_step: "Infraction step",
    action_type: "Action type",
    combined_lts_ltc: "Combined (LTS & LTC)",
    no_items_available: "No items available",
    no_items: "No items",
    no_filtering_results: "No filtering results",
    color: "Color",
    none: "none",
    a11y_color_picker_trigger_label:
      "{label}. Selected {currentColor}. Press Enter or Space to open color options.",
    a11y_datepicker_previous_month: "Previous month",
    a11y_datepicker_next_month: "Next month",
    a11y_input_default_accessible_name: "Text input",
    a11y_textarea_default_accessible_name: "Text field",
    a11y_timepicker_am_pm_toggle: "Switch AM/PM mode, {period}",
    a11y_combobox_results_available: "{count} results available",
    a11y_combobox_expanded: "expanded",
    a11y_combobox_collapsed: "collapsed",
    a11y_combobox_active_option: "{label}, {index} of {total}",
    a11y_combobox_active_option_selected:
      "{label}, {index} of {total}, selected",
    a11y_key: "Key",

    // DataTable and Pagination
    search: "Search",
    sort: "Sort",
    export: "Export",
    filter_tabs: "Filter tabs",
    showing: "Showing",
    entries: "entries",
    all_entries: "All entries",
    per_page: "per page",
    showing_to: "to",
    showing_of: "of",
    entries_per_page: "Rows per page",
    table_row_actions_open_menu: "Open Actions menu",
    table_row_actions_close_menu: "Close Actions menu",
    table_row_actions_open_menu_for: "Open Actions menu for {name}",
    table_row_actions_close_menu_for: "Close Actions menu for {name}",
    table_row_actions_menu: "Row actions",
    table_row_actions_menu_for: "Actions for {name}",
    a11y_bulk_action: "Bulk action",
    a11y_bulk_action_with_id: "Bulk action {id}",
    a11y_loading: "Loading",
    a11y_loading_users_table: "Loading users",
    a11y_loading_archived_users_table: "Loading archived users",
    a11y_loading_substitute_users_table: "Loading substitute users",
    a11y_no_substitute_users_available: "No substitute users available.",
    a11y_substitute_users_shown:
      "Showing {from} to {to} of {total} substitute users.",
    a11y_loading_tardy_reports: "Loading tardy reports",
    a11y_loading_pass_totals: "Loading pass totals reports",
    a11y_no_report_rows_match_filters:
      "No rows match the current report filters.",
    a11y_report_rows_shown: "Showing {count} row(s).",
    a11y_generating_summary_report:
      "We are generating your report. Please do not move away from this page.",
    a11y_processing_csv_upload: "Uploading tardy CSV file, please wait",
    a11y_help_open_header_help_menu:
      "Open Help Center: main header help (navigation and account)",
    a11y_help_open_student_header_help:
      "Open Help Center: student toolbar help",
    a11y_favorite_carousel_page:
      "Favorites carousel, slide {current} of {total}",

    // Favorites
    edit_sort_favorites: "Edit / Sort Favorites",
    favorites_note: "Note",
    can_see_and_sort_favorites:
      "can see and sort / delete their favorite(s) only.",
    icon: "Icon",
    name: "Name",
    action: "Action",
    delete: "Delete",

    // Form labels
    note: "Note",
    date: "Date",
    period: "Period",
    time: "Time",
    reason: "Reason",
    from: "From",
    to: "To",
    status: "Status",
    actions: "Actions",
    school_year: "School year",
    grad_year: "Grad Year",
    by_grad_year: "By Grad Year",
    date_range: "Date range",
    reason_for_visit: "Reason for visit",
    search_visitors: "Search visitors",
    toggle_filters: "Toggle filters",
    download_export: "Download export",
    tardy_csv_upload_file_type: "Type (LTS or LTC)",
    tardy_csv_upload_attendance_file: "Attendance file",
    tardy_report_filter_options: "Tardy types and columns",
    tabs: "Tabs",

    // Status and conditions
    late_to_school: "Late to School",
    late_to_class: "Late to Class",
    no_passes: "No Passes",
    todays_history: "Today's History",
    a11y_time_in_pass_value:
      "Elapsed duration in this pass (not a clock time): {time}",
    a11y_total_pass_time_value:
      "Total duration for this pass (not a clock time): {time}",
    a11y_time_remaining_on_request:
      "Time remaining on approval request, {time}",
    a11y_todays_pass_history_button: "Today's history, {count} passes today",
    a11y_clear_field_selection: "Clear selection, {field}",
    a11y_activate_restricted_module: "Activate restricted module, {name}",
    a11y_pass_comments_count_one: "1 comment",
    a11y_pass_comments_count_many: "{count} comments",
    a11y_open_pass_comments_for_student:
      "Open comments for {name} ({countPhrase})",
    a11y_open_pass_comments_for_pass_id:
      "Open comments for pass {id} ({countPhrase})",
    a11y_open_pass_comments_generic: "Open comments ({countPhrase})",
    currently_waiting_in_line: "Currently waiting in line",
    comments: "Comments",
    you_are: "You are",
    start: "Start",
    stop: "Stop",
    this_student_is_flagged_for_3_unsuccessful_pin_attempts:
      "This student is flagged for 3 unsuccessful PIN attempts",
    currently_waiting_for_approval: "Currently waiting for approval!",
    total_time_today: "Total time today",
    no_passes_for_today: "No passes for today.",
    number_of_signatures: "# of signatures",
    time_out: "Time Out",
    final_time_in: "Final Time In",
    total_time: "Total Time",

    // Pass status labels
    in_queue: "In Queue",
    waiting_approval: "Waiting Approval",
    active: "Active",
    ended: "Ended",
    canceled: "Canceled",

    // Pass completion types
    auto_pass: "Auto Pass",
    system_ended: "System Ended",
    unknown: "Unknown",
    successfully_updated: "Successfully updated.",

    // Form components
    select: "Select",
    select_location: "Select location",
    loading_more: "Loading more..",
    form_submitting: "Submitting, please wait.",
    sorry_no_matching_options: "Sorry, no matching options.",
    more: "more",

    // Comments component
    no_comments: "No comments",
    type_your_comment_here: "Type your comment here ...",
    characters_max: "{count} characters max",
    comment: "Comment",
    the_comment_is_required: "The comment is required!",
    successfully_created: "Successfully created!",
    the_comments_field_is_required: "The comments field is required!",
    something_went_wrong: "Something went wrong!",
    my_profile: "My profile",
    my_locations: "My locations",
    premium_feature: "(Premium Feature)",
    first_name: "First name",
    last_name: "Last name",
    email: "Email",
    appointment_requests_to_you: "Appointment requests to you",
    when_the_toggle_is_blue_students_will_be_able_to_create_appointment_requests_to_you:
      "When the toggle is blue, students will be able to create appointment requests to you.",
    email_notification: "Email notification",
    bell_notification: "Bell notification",
    notifications_for_appointment_requests:
      "Notifications for Appointment Requests",
    passes_to_from_you: "Passes to/from you",
    when_the_toggle_is_blue_adults_and_students_will_be_able_to_create_passes_to_from_you:
      "When the toggle is blue, adults and students will be able to create passes to/from you.",
    appointment_pass_email_reminders: "Appointment Pass email reminders",
    select_which_appointment_pass_reminder_emails_to_be_sent_to_you:
      "Select which Appointment Pass reminder emails to be sent to you.",
    your_pin_needs_to_be_between_4_and_6_letters_numbers_or_characters_long_any_combination_of_these_but_no_spaces:
      "Your PIN needs to be between 4 and 6 letters, numbers or characters long (any combination of these, but no spaces).",
    kiosk_passcode: "Kiosk passcode",
    save_changes: "Save changes",
    pin: "PIN",
    "20_minute": "20 - minute",
    "5_minute": "5 - minute",
    max_35_characters: "max 35 characters",
    clear_all_notifications: "Clear all notifications",
    no_new_notifications: "No new notifications",
    delete_image: "Delete image",
    a11y_mute_notification_sounds: "Mute notification sounds",
    a11y_unmute_notification_sounds: "Unmute notification sounds",
    a11y_locations_selected_count: "Locations selected: {count}",
    upload_profile_photo: "Upload or change profile photo",
    selected: "Selected",
    capture_via: "Capture via",
    open_capture_settings: "Open capture settings",
    close_capture_settings: "Close capture settings",
    android: "Android",
    app: "App",
    computer: "Computer",
    this_image_is_too_large_allowed_maximum_size_is_2mb:
      "This image is too large. Allowed maximum size is 2MB",
    unsupported_image_type: "Unsupported image type",
    favorites_limit_reached:
      'You have reached the "Favorites" limit. To add a new location you must delete a previous selection.'
  },

  colorPicker: {
    dialogAriaLabel: "Color picker dialog",
    selectColor: "Select {color}",
    selectColorSelected: "Select {color}, selected",
    selectColorFallback: "Select color"
  },

  // Language selection
  language: {
    select_language: "Select language"
  },

  // Sidebar navigation items (also used for route names)
  sidebar_items: {
    home: "Home",
    dashboard: "School Dashboard",
    history: "History",
    create_pass: "Create Pass",
    active_pass: "Active Pass",
    teacher_pass: "Teacher Pass",
    appointments: "Appointments",
    digital_id: "Digital ID",
    tardy_management: "Tardy Management",
    tardy_reports: "Tardy Reports",
    tardy_detention_appointment_list: "Tardy Detention & Appointment List",
    tardy_appointments: "Tardy Appointments",
    detention_attendance: "Detention Attendance",
    detention_calendar: "Detention Calendar",
    tardy_settings: "Tardy Settings",
    tardy_adults: "Tardy Adults",
    tardy_csv_upload: "Tardy CSV Upload",
    tardy_detentions: "Tardy Detention(s)",
    consequences_ladder: "Consequences Ladder",
    visitor_management: "Visitor Management",
    visitor_settings: "Visitor Settings",
    visitor_adults: "Visitor Adults",
    visitor_guardian_student_matrix:
      "Visitor Guardian/Student Matrix (Parent/Student Matrix)",
    check_ins_and_reports: "Check-ins and Reports",
    printer_setup: "Printer Setup",
    queue_settings: "Queue Settings",
    behaviour_management_settings: "Behavior Management Settings",
    retained: "Retained",
    limits: "Limits",
    limit_student_pass: "Limit Student Pass",
    limit_location_max_cap: "Limit Location Max Cap",
    limit_active_pass: "Limit Active Pass",
    limit_location_availability: "Limit Location Availability",
    contact_control_ab_polarity: "Contact Control (A/B Polarity)",
    pass_blocking: "Pass Blocking",
    users: "Users",
    main_users: "Main Users",
    substitute_users: "Substitute Users",
    archived_users: "Archived Users",
    system_settings: "System Settings",
    auto_pass: "Auto Pass",
    pass_times: "Pass Times",
    periods: "Periods",
    locations_rooms: "Locations (rooms)",
    pass_transparency: "Pass Transparency",
    modules: "Modules",
    file_uploads: "File Uploads",
    security_alerts_settings: "Security Alerts",
    kiosk: "Kiosk",
    kiosk_settings: "Kiosk Settings",
    out_of_office: "Out of Office",
    general_settings: "General Settings",
    list_settings: "List Settings",
    help_desk: "Help Desk",
    updates: "Updates",
    training: "Training",
    documents: "Documents",
    video_tutorials: "Video Tutorials",
    control_panel: "Admin Control Panel",
    reports: "School Reports",
    summary_reports: "Summary Reports",
    meet_up_report: "Meet-up Report",
    pass_totals: "Pass Totals",
    profile_settings: "Profile Settings",
    login: "Login",
    forgotten_password: "Forgotten Password",
    reset_password: "Reset Password",
    verify_email: "Verify Email",
    kiosk_login: "Kiosk Login",
    kiosk_system: "Kiosk System",
    locked: "Locked",
    acknowledged_pass: "Acknowledged Pass",
    not_found: "Not Found",
    form_components_examples: "Form Components Examples",
    advanced_reporting: "Advanced Reporting",
    scheduled_reports: "Scheduled Reports",
    district_school_insights: "District & School Insights"
  },

  behaviour_settings: {
    tabs_aria_label: "{behaviourManagement} settings sections",
    tab_core_value: "Core value",
    tab_positive_behaviours: "Positive behaviors",
    tab_automated_points: "Automated points",
    tab_customized_theme: "Customized theme",
    core_value_section_title: "Core value settings",
    empty_tab_title: "Behavior settings",
    empty_tab_body: "This section will be available in a future update.",
    status_filter_label: "Filter by status",
    status_all: "All",
    status_active: "Active",
    status_inactive: "Inactive",
    reset_filters: "Reset Filters",
    upload_csv: "Upload CSV",
    upload_csv_submit: "Submit",
    upload_core_value_csv_title: "Upload a CSV of {coreValuesLower}",
    upload_positive_behaviours_csv_title:
      "Upload a CSV of {positiveBehaviours}",
    upload_csv_file_label_core_value: "{coreValue} CSV file",
    upload_csv_file_label_positive_behaviours: "{positiveBehaviours} CSV file",
    upload_csv_error_required_file: "File is required.",
    upload_csv_error_title: "Error",
    upload_csv_error: "Could not upload CSV. Please try again.",
    upload_csv_success_title: "Success",
    upload_csv_success: "{inserted} of {total} rows imported successfully.",
    upload_csv_partial_success_title: "Partial success",
    upload_csv_partial_success:
      "{inserted} of {total} rows imported. {failed} row(s) failed.",
    upload_csv_all_failed_title: "Import failed",
    upload_csv_all_failed: "No rows were imported. {failed} of {total} failed.",
    upload_csv_row_errors_title: "Import errors",
    add_core_value: "Add core value",
    no_rows: "No core values match the current filters.",
    col_name: "Name",
    col_description: "Description",
    col_points: "{points}",
    col_status: "Status",
    col_actions: "Actions",
    action_edit: "Edit",
    action_delete: "Delete",
    action_switch_off: "Switch off",
    action_switch_on: "Switch on",
    action_disable: "Disable",
    action_enable: "Enable",
    lazy_scroll_hint: "Scroll down to load more rows",
    indicator_a11y: "Status indicator: {color}",
    announce_loaded_paginated:
      "Showing {count} of {total} core values on this page.",
    announce_loaded_lazy:
      "Loaded {count} of {total} core values. Scroll the table to load more.",
    announce_lazy_more:
      "Loaded {visible} of {total} core values into the table.",
    save: "Save",
    frequency_label: "Frequency",
    frequency_daily: "Daily",
    frequency_weekly: "Weekly",
    frequency_monthly: "Monthly",
    core_value_select_placeholder: "Selected {coreValue}",
    points_placeholder: "Placeholder/Disabled",
    automated_rule_toggle_a11y: "Enable {rule}",
    automated_points_saved: "Automated points settings saved.",
    automated_points_cancelled: "Changes discarded.",
    automated_points_load_error:
      "Could not load automated points settings. Please try again.",
    automated_points_save_error:
      "Could not save automated points settings. Please try again.",
    automated_points_validation_error:
      "Complete frequency, {coreValuesLower}, and {points} for each enabled rule.",
    automated_points_error_required_field: "{field} is required.",
    theme_field_behaviour_management: "Behavior Management",
    theme_field_core_value: "Core value",
    theme_field_positive_behaviours: "Positive behaviors",
    theme_field_points: "Points",
    rename_labels_toggle_a11y: "Enable {section}",
    theme_label_validation_error:
      "Enter 1–25 alphanumeric characters (letters, numbers, and spaces).",
    customized_theme_saved: "Customized theme settings saved.",
    customized_theme_cancelled: "Changes discarded.",
    customized_theme_load_error:
      "Could not load customized theme settings. Please try again.",
    customized_theme_save_error:
      "Could not save customized theme settings. Please try again.",
    customized_theme_validation_error:
      "Complete all label fields when rename is enabled.",
    core_value_status_label: "Status",
    core_value_name_label: "{coreValue} name",
    core_value_description_label: "Description",
    core_value_color_label: "Category color",
    core_value_active_label: "Enabled",
    core_value_active_toggle_a11y: "Set {coreValue} as enabled",
    create_core_value_submit: "Submit",
    update_core_value_submit: "Submit",
    edit_core_value_title: "Edit {coreValue}",
    delete_core_value_title: "Delete {coreValue}",
    delete_core_value_message:
      "This {coreValue} contains other behavior items connected to it. Please select new {coreValue} to reassign these items to.",
    delete_core_value_transfer_label: "New {coreValue}",
    delete_core_value_transfer_placeholder: "Select {coreValue}",
    delete_core_value_transfer_required: "Select a {coreValue} for transfer.",
    delete_core_value_no_transfer_targets:
      "At least one other {coreValue} is required before this item can be deleted.",
    delete_core_value_confirm: "Delete",
    delete_core_value_error: "Could not delete {coreValue}. Please try again.",
    core_value_created_success: "{coreValue} created successfully.",
    core_value_updated_success: "{coreValue} updated successfully.",
    core_value_deleted_success: "{coreValue} deleted successfully.",
    core_value_disabled_success: "{coreValue} disabled.",
    core_value_enabled_success: "{coreValue} enabled.",
    core_value_created_error: "Could not create {coreValue}. Please try again.",
    core_value_list_load_error:
      "Could not load {coreValuesLower}. Please try again.",
    core_value_updated_error: "Could not update {coreValue}. Please try again.",
    core_value_error_title: "Error",
    core_value_error_required: "This field is required.",
    core_value_error_required_field: "{field} is required.",
    core_value_error_max_length: "Maximum {max} characters.",
    core_value_error_duplicate: "A {coreValue} with this name already exists.",
    core_value_error_invalid_color: "Choose a color from the palette.",
    core_value_error_points_range: "Enter a whole number from {min} to {max}.",
    positive_behaviour_status_label: "Status",
    positive_behaviour_name_label: "{positiveBehaviours} name",
    positive_behaviour_award_description_label: "Award description",
    positive_behaviour_points_label: "{points} awarded",
    positive_behaviour_core_value_placeholder: "Select {coreValue}",
    positive_behaviour_core_values_loading: "Loading {coreValuesLower}…",
    positive_behaviour_core_values_load_error:
      "Could not load {coreValuesLower}. Please try again.",
    create_positive_behaviour_submit: "Submit",
    update_positive_behaviour_submit: "Submit",
    edit_positive_behaviour_title: "Edit {positiveBehaviours}",
    delete_positive_behaviour_title: "Delete {positiveBehaviours}",
    delete_positive_behaviour_message:
      "Are you sure you want to delete this {positiveBehaviours}? Deleting it will not affect any points and awards given in the past.",
    delete_positive_behaviour_confirm: "Delete",
    delete_positive_behaviour_error:
      "Could not delete {positiveBehaviours}. Please try again.",
    positive_behaviour_created_success:
      "{positiveBehaviours} created successfully.",
    positive_behaviour_updated_success:
      "{positiveBehaviours} updated successfully.",
    positive_behaviour_deleted_success:
      "{positiveBehaviours} deleted successfully.",
    positive_behaviour_disabled_success: "{positiveBehaviours} disabled.",
    positive_behaviour_enabled_success: "{positiveBehaviours} enabled.",
    positive_behaviour_list_load_error:
      "Could not load {positiveBehaviours}. Please try again.",
    positive_behaviour_created_error:
      "Could not create {positiveBehaviours}. Please try again.",
    positive_behaviour_updated_error:
      "Could not update {positiveBehaviours}. Please try again.",
    positive_behaviour_error_title: "Error",
    positive_behaviour_error_required_field: "{field} is required.",
    positive_behaviour_error_max_length: "Maximum {max} characters.",
    positive_behaviour_error_duplicate:
      "A {positiveBehaviours} with this name already exists.",
    positive_behaviour_error_points_range:
      "Enter a whole number from {min} to {max}."
  },

  behaviour_manage: {
    student_list_coming_soon:
      "Student list will be available in a future update.",
    col_student_name: "Student name",
    col_student_number: "Student number",
    col_user_email: "User email ID",
    col_total_points: "Total points",
    col_remaining_points: "Remaining {point}",
    no_student_list_rows: "No students match the current filters.",
    table_scroll_region: "{name} table; scroll horizontally for more columns",
    view_student_point_history: "View {point} history for {name}",
    back_to_student_list: "Back to student list",
    date_range_sample: "Oct 13, 2025",
    action_award: "Award",
    action_point_correction: "{point} correction",
    action_redeem: "Redeem",
    col_student: "Student",
    col_to: "To",
    col_from: "From",
    col_activity: "Activity",
    col_transaction_type: "Type",
    col_awarded_by: "Awarded by",
    filter_behavior: "Behavior",
    filter_activity_type: "Activity type",
    col_notes: "Notes",
    notes_tooltip_aria_label: "Notes: {notes}",
    notes_not_found: "No notes found",
    notes_not_found_aria_label: "Notes: no notes found",
    col_date_time: "Date & time",
    transaction_type_award: "Award",
    transaction_type_redeem: "Redeem",
    transaction_type_correction: "Correction",
    activity_reward_redeemed: "Reward Redeemed",
    activity_point_correction: "{point} Correction",
    no_point_history_rows: "No {point} history matches the current filters.",
    redeem_reward_title: "Redeem Reward",
    point_correction_title: "{point} Correction",
    award_points_title: "Award {points}",
    points_used_label: "{points} used",
    points_corrected_label: "{points} corrected",
    points_corrected_hint:
      "(Note - If correction is to remove {points}, type in a dash before the number. Example: To remove five {points}: -5. To add five {points}: 5.)",
    reward_reason_label: "Reward/Reason",
    correction_reason_label: "Reason",
    select_students_fieldset: "Select Students",
    select_students_label: "Select Students",
    select_students_placeholder: "Select students",
    select_student_placeholder: "Select student",
    select_positive_behaviour_placeholder: "Select {positiveBehaviours}",
    select_core_value_first_placeholder: "Select a {coreValue} first",
    student_details_fieldset: "Select Students",
    redeem_submit: "Redeem",
    correction_submit: "Submit",
    award_submit: "Submit",
    error_required_field: "{field} is required.",
    error_select_students: "Select at least one student.",
    error_title: "Error",
    stat_redeemed_info: "Points redeemed by students",
    award_success: "{points} awarded successfully.",
    redeem_success: "{points} redeemed successfully.",
    correction_success: "Point correction submitted successfully.",
    award_error: "Could not award {points}. Please try again.",
    redeem_error: "Could not redeem {points}. Please try again.",
    correction_error: "Could not submit point correction. Please try again.",
    insufficient_points_error:
      "Student does not have enough points for this operation.",
    notification_pbis_badge_award: "POINTS AWARDED",
    notification_pbis_badge_redeem: "REDEEMED",
    notification_pbis_badge_correction: "CORRECTION",
    notification_pbis_badge_default: "POINTS UPDATE",
    notification_pbis_staff_fallback: "Staff",
    notification_pbis_points_fallback: "points",
    notification_pbis_award:
      "You received {points} {pointsLabel} from {staff} for {reason}.",
    notification_pbis_redeem: "You redeemed {points} {pointsLabel}.",
    notification_pbis_correction:
      "Your {pointsLabel} were adjusted by {staff}.",
    notification_pbis_reason_suffix: " Reason: {reason}.",
    notification_pbis_reason_fallback: "a positive behavior",
    notification_pbis_default:
      "You received a {pointsLabel} update from {staff}."
  },

  digital_id_card: {
    page_title: "Digital ID",
    digital_id: "Digital ID",
    student_id: "Student ID",
    graduation_year: "Graduation Year",
    role: "Role",
    missing_student_id:
      "This student does not have a Student Number in the system.",
    suicide_prevention_hotline: "National Suicide Prevention Hotline",
    suicide_prevention_text: "or call/text 988",
    download_digital_id: "Download Digital ID"
  },

  create_pass_student_view: {
    now_pass: "Now Pass",
    appointment_pass: "Appointment Pass",
    late_pass: "Late Pass",
    departing_from: "Departing From",
    teacher_location: "Teacher/Location",
    teacher_location_placeholder: "Teacher/Location",
    destination: "Destination",
    reason_for_pass_optional: "Reason for pass (optional)",
    reason_for_pass_required: "Reason for pass (required)",
    successfully_created: "Successfully created.",
    maximum_capacity_of_the_location_has_been_reached:
      "Maximum capacity of the location has been reached. Please try again when a student returns.",
    this_location_is_full:
      "This location is full. Click 'Submit' to join the line, and Pass will let you know when it is your turn.",
    requests_available: "Request(s) available",
    now_passes_available: "Now Passes Available",
    appointment_passes_available: "Appointment Passes Available",
    the_module_is_not_available: "The Module Is Not Available",
    this_destination_is_unavailable_until:
      "This destination is unavailable until",
    this_room_is_unavailable_until: "This room is unavailable until",
    this_adult_is_unavailable_until: "This adult is unavailable until",
    pass_limit: "Pass Limit",
    mark_this_pass_as: "Mark this pass as:",
    appointment_pass_created_successfully:
      "Appointment pass created successfully",
    you_have_location_restrictions:
      "You have ({restrictions}) location restrictions"
  },

  // Appointment Pass specific translations
  appointment_pass: {
    // Page title
    page_title: "Appointment Pass page",

    // Table tabs
    next_seven_days: "Next 7 Days",
    beyond_seven_days: "Beyond 7 Days",
    recurring: "Recurring",

    // Table headers
    confirmed_canceled: "Confirmed/Canceled",

    // Status labels
    waiting_confirmation: "Waiting Confirmation",
    canceled: "Canceled",
    future_apt: "Future Apt",
    todays_apt: "Today's APT",
    missed_apt: "Missed apt",
    ended: "Ended",
    on_other_pass: "On other pass",
    missed_request: "Missed request",

    // Table content
    confirmed: "Confirmed",
    cancelled: "Cancelled",
    does_not_repeat: "Does not repeat",
    acknowledge: "Acknowledge",
    requested: "Requested",
    created: "Created",
    expired: "Expired",

    // Modal titles
    comments_title: "Comments",
    cancel_pass_title: "Cancel Pass",

    // Cancel modal content
    message_placeholder: "Message...",
    cancel_future_occurrences: "Just Cancel Future Occurrences",
    cancel_current_week_and_future:
      "Cancel Current Week And Future Occurrences",
    delete_only_this_instance: "Delete only this instance",
    delete_entire_series: "Delete entire series",
    cancel_series_message:
      "There may be instances of this series already scheduled on the 'Next 7 Days' tab. Do you want to cancel all of those as well?",
    delete_instance_message:
      "Do you want to delete only this instance or the entire series?",

    // Success modal
    appointment_request_sent: "Appointment Request Sent for",
    apt_menu: "Apt Menu",

    // Notification
    your_appointment_pass_is_ready: "Your Appointment Pass is now ready",
    from_teacher: "From Teacher",
    from_location: "From Location",
    to_teacher: "To Teacher",
    to_location: "To Location",
    go_to_pass: "Go To Pass",

    // A11y — student appointment comments (keyboard-accessible controls)
    a11y_open_comments: "Open comments ({count})",
    a11y_open_comments_thread: "Open full comment thread"
  },

  // Updates and Training
  updates: {
    page_title: "New Releases",
    no_releases: "No releases",
    pass_updates: "Pass Updates",
    release_date: "Release Date",
    release_doc_iframe_title: "Release notes"
  },

  training: {
    page_title: "Training Videos",
    no_tutorials: "No tutorials at the moment",
    topic: "Topic",
    description: "Description",
    video_iframe_title: "{topic} — video tutorial"
  },

  admin_guide: {
    page_title: "Admin's Guide",
    no_tutorials: "No tutorials at the moment"
  },

  quick_reference: {
    page_title: "Quick Reference",
    no_data: "No data at the moment"
  },

  // Kiosk specific translations
  kiosk: {
    // General kiosk terms
    a11y_profile_photo: "Signed-in user profile photo",
    a11y_profile_photo_named: "Signed-in user profile photo: {name}",
    kiosk_mode: "Kiosk Mode",
    kiosk_status_tabs: "Kiosk list status",
    no_active_kiosk: "No active kiosk.",
    ksk: "KSK",

    // Authentication
    teacher_authentication: "TEACHER AUTHENTICATION",
    user_authentication: "User authentication",
    nav_aria_label: "Kiosk steps",
    nav_step_login: "Login",
    nav_step_select: "New Pass / End Pass",
    nav_step_action: "Pass details",
    nav_step_active: "Pass status",
    code: "Code",
    enter_your_pin: "Enter your PIN",
    kiosk_passcode: "Kiosk passcode",

    // Login methods
    student_number: "Student Number",
    code_scan: "Code scan",
    card_scan: "Card scan",
    email: "Email",
    email_domain: "Email domain",
    enter_student_number_below: "Enter your student number below",
    type_in_student_number: "Type in student number",
    swipe_your_card: "Swipe your card",
    click_to_scan_barcode_or_qr: "Click to scan Barcode or QR",
    type_in_barcode_qr_code: "Type in barcode/QR code",
    scan_your_digital_id_barcode_qr_code:
      "Scan your Digital ID barcode/QR code",

    // Main screen
    from: "From:",
    new_pass: "New Pass",
    student_late_pass: "Student late pass (SLP)",
    create_pass_tabs: "Create pass types",
    mark_this_pass_as: "Mark this pass as:",
    end_pass: "End Pass",
    departing_from: "Departing From",

    // Pass creation
    destination: "Destination",
    reason: "Reason",
    or_quick_select_from: "or quick select from",
    favorites: "Favorites",
    note: "Note:",
    the_student_already_has_an_active_pass:
      "The student already has an active pass.",
    this_screen_will_be_closed_in: "This screen will be closed in",
    seconds: "seconds",
    or_click_here_to_close_it_now: "(or click here to close it now)",

    // Pass status and actions
    your_pass_is_approved: "Your pass is approved.",
    your_pass_request_is_in_the_queue:
      "Your pass request is in the queue. It will be reviewed by a teacher once it reaches the front, as the maximum number of passes for this location has been reached.",
    your_pass_is_created_and_awaiting_approval:
      "your pass is created and is awaiting approval from your teacher's dashboard or this Kiosk.",
    auto_pass: "Auto Pass",
    time: "Time",
    staff_use_only: "Staff use only",
    waiting_approval: "waiting approval",
    active: "active",
    waiting_in_queue: "waiting in queue",
    ended: "Ended",
    canceled: "Canceled",
    cancel: "Cancel",
    close: "Close & return to login",
    approve: "Approve",
    start: "Start",
    submit: "Submit",
    continue: "Continue",
    cancel_queue_pass: "Cancel Queue Pass",
    please_select_different_teacher_location:
      "Please select a different teacher/location.",

    // Pass ending
    end_pass_title: "End Pass.",
    you_do_not_have_an_active_pass: "You do not have an active pass.",
    pass_limit: "Pass Limit",
    no_passes_left: "You have no passes left",
    close_button: "Close",
    cancel_with_timeout: "Cancel",
    end_pass_button: "End Pass",
    pass_ended: "Pass ended",

    // Pass status messages
    your_pass_has_successfully_been_ended:
      "Your pass has successfully been ended.",
    your_queue_pass_has_successfully_been_ended:
      "Your queue pass has successfully been ended.",
    your_pass_has_successfully_been_approved:
      "Your pass has successfully been approved.",
    successfully_logged: "Successfully Logged.",
    successfully_created: "Successfully created!",
    something_went_wrong: "Something went wrong!",
    this_field_is_required: "This field is required",
    submission_failed_please_try_again: "Submission failed, please try again.",

    // Terms and privacy
    terms_of_use: "Terms of Use",
    privacy_policy: "Privacy policy",

    // Unavailability messages
    this_room_is_unavailable_until: "This room is unavailable until",
    this_adult_is_unavailable_until: "This adult is unavailable until",

    // Reason placeholders
    reason_for_pass_optional: "Reason for pass (optional)",
    reason_for_pass_required: "Reason for pass (required)",

    // Confirmation dialogs
    confirm_cancel_pass: "Are you sure you want to cancel this pass?"
  }
})
